import Vue from 'vue'
import Router from 'vue-router'
import {Erroring, Home, Course, Result, Upload, Loading} from '@/components/index.js'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/course',
      name: 'index',
      component: Course,
      alias: '/index'
    },
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/upload',
      name: 'upload',
      component: Upload
    },
    {
      path: '/loading',
      name: 'loading',
      component: Loading
    },
    {
      path: '/result',
      name: 'result',
      component: Result
    },
    {
      path: '/error',
      name: 'error',
      component: Erroring
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js